<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <h1 class="title-default">Minhas exportações de dados</h1>
        <p class="welcome-message">
            <button mat-icon-button routerLink="../">
                <mat-icon>arrow_back</mat-icon>
            </button>
            Apenas seu usuário tem acesso às exportações de dados aqui.
        </p>


        <div class="row search-area">
            <div class="col-12">
                <button mat-stroked-button type="button" class="btn-filter margin-right-15"
                    [matMenuTriggerFor]="filtroMenu" [matBadge]="qtdFiltrosAvancados"
                    [matBadgeHidden]="qtdFiltrosAvancados === 0">
                    <mat-icon>filter_list</mat-icon>
                    Filtrar
                </button>
                <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                    <div class="filter-menu-content" [formGroup]="formFiltro">
                        <div (click)="$event.stopPropagation()">
                            <h6>Filtros Avançados</h6>
                            <div class="filter-menu__form">
                                @if(listTipoExtracao){
                                <app-select-pesquisavel [control]="idTipoExtracaoControl"
                                    [offlineList]="listTipoExtracao" label="Tipo de Exportação" idField="idTipoExtracao"
                                    nameField="tipoExtracao" [isOptional]="true" [multiple]="true" [showBadges]="true">
                                </app-select-pesquisavel>
                                }
                                @if(listStatusExtracao){
                                <app-select-pesquisavel [control]="idStatusExtracaoControl"
                                    [offlineList]="listStatusExtracao" label="Status Extração"
                                    idField="idStatusExtracao" nameField="nomeStatus" [isOptional]="true"
                                    [multiple]="true" [showBadges]="true">
                                </app-select-pesquisavel>
                                }
                            </div>
                        </div>
                        <div class="filter-menu__actions">
                            <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                            <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                                Aplicar
                            </button>
                        </div>
                    </div>
                </mat-menu>

                <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                    <mat-icon>cleaning_services</mat-icon>
                    Limpar Filtros
                </button>
            </div>
        </div>

        @if (_listaPedidoExtracaoResponse && dataSource.data.length > 0) {
        <!-- Table (Desktop) -->
        <div class="desktop-view">
            <table mat-table [dataSource]="dataSource">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> ID </th>
                    <td mat-cell *matCellDef="let element"> {{element.pedidoExtracao.idPedidoExtracao}} </td>
                </ng-container>

                <ng-container matColumnDef="tipo">
                    <th mat-header-cell *matHeaderCellDef> Tipo </th>
                    <td mat-cell *matCellDef="let element"> {{element.nomeTipoExtracao}} </td>
                </ng-container>

                <ng-container matColumnDef="dataHora">
                    <th mat-header-cell *matHeaderCellDef> Data Pedido </th>
                    <td mat-cell *matCellDef="let element"> {{element.pedidoExtracao.datetimeInclusao | date:'dd/MM/yyyy
                        HH:mm'}} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="status-badge" [ngClass]="getStatusClass(element.pedidoExtracao.idStatusExtracao)"
                            [matTooltip]="(element.pedidoExtracao.erroExtracao ? element.pedidoExtracao.erroExtracao : '')">
                            {{element.statusExtracao}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="mensagem">
                    <th mat-header-cell *matHeaderCellDef> Mensagem </th>
                    <td mat-cell *matCellDef="let element" class="coluna-mensagem">
                        {{element.pedidoExtracao.erroExtracao}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element"
                        [matTooltip]="element.statusLink === 'EXPIRADO' ? 'Prazo de 3 dias para download excedido' : 'Baixar arquivo'">
                        <button mat-icon-button (click)="download(element)"
                            [disabled]="!element.pedidoExtracao.urlArquivo || element.statusLink === 'EXPIRADO'">
                            <mat-icon>download</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

        <!-- Mobile View (Cards) -->
        <div class="mobile-view">
            @for (item of dataSource.data; track item.pedidoExtracao.idPedidoExtracao) {
            <div class="card-mobile mb-3">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <span class="text-bold">#{{item.pedidoExtracao.idPedidoExtracao}} -
                            {{item.nomeTipoExtracao}}</span>
                    </div>
                    <span
                        [matTooltip]="item.statusLink === 'EXPIRADO' ? 'Prazo de 3 dias para download excedido' : 'Baixar arquivo'">
                        <button mat-icon-button (click)="download(item)"
                            [disabled]="!item.pedidoExtracao.urlArquivo || item.statusLink === 'EXPIRADO'">
                            <mat-icon>download</mat-icon>
                        </button>
                    </span>
                </div>
                <div class="card-body-mobile p-3">
                    <p class="mb-1"><small>Data pedido:</small> {{item.pedidoExtracao.datetimeInclusao |
                        date:'dd/MM/yyyy
                        HH:mm'}}
                    </p>
                    <span class="status-badge" [ngClass]="getStatusClass(item.pedidoExtracao.idStatusExtracao)"
                        [matTooltip]="item.pedidoExtracao.erroExtracao || ''">
                        {{item.statusExtracao}}
                    </span>
                    @if (item.pedidoExtracao.erroExtracao) {
                    <p class="mb-0 mt-2 coluna-mensagem"><small>{{item.pedidoExtracao.erroExtracao}}</small></p>
                    }
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                }
                @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>

        } @else if(isLoading === true && dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list message="Nenhuma exportação encontrada."></app-empty-list>
        }

    </div>
</div>